import { render, staticRenderFns } from "./NotificationsBox.vue?vue&type=template&id=def5a68c&scoped=true"
import script from "./NotificationsBox.vue?vue&type=script&lang=js"
export * from "./NotificationsBox.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=def5a68c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def5a68c",
  null
  
)

export default component.exports